import {
  StyledIconClose,
  StyledIconHourglass,
  StyledIconWarningTriangle
} from 'Components/Icons'
import { SOURCES_UPDATE_STATUS_KO } from 'Constants'
import { storeGet } from 'Helpers/localStorage'
import { fromUTCtoZoneFormatted, STORE_KEY_LIST } from 'mailup-react-helpers'
import {
  DataListExtraColumn,
  DataListRow,
  Flex,
  Grid,
  GridCell,
  ICON_FA_VARIANT_SOLID,
  Link,
  SKELETON_LOADER_VARIANT_ONWHITE,
  SkeletonLoader,
  Text,
  TEXT_VARIANT_SMALL_LIGHT,
  TooltipUtils,
  TruncateAndTooltip
} from 'mailup-web-components'
import { fetchMoreResultsCallback } from 'Pages/SourcesList/recoil/callbacks/callbacks'
import { modalSharedListsState } from 'Pages/SourcesList/recoil/state/modals'
import { moreResults } from 'Pages/SourcesList/recoil/state/page'
import PropTypes from 'prop-types'
import { useEffect } from 'react'

import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import ActionsMenu from './ActionsMenu'

const ItemTable = ({ dataRow, heads, key }) => {
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)
  const intl = useIntl()
  const history = useHistory()

  const { moreLoaded, moreLastContentUpdates, moreContentsNumber, moreShared } =
    useRecoilValue(moreResults(dataRow.Id))

  const fetchMoreResults = useRecoilCallback(fetchMoreResultsCallback, [])

  const { saving: showModalSharedList } = useRecoilValue(modalSharedListsState)

  const EXTRA_COLUMN_AFTER_WIDTH = '30px'

  useEffect(() => {
    fetchMoreResults(dataRow.Id).then((e) =>
      setTimeout(() => TooltipUtils.rebuild())
    )
  }, [dataRow.Id])

  useEffect(() => {
    if (showModalSharedList) {
      fetchMoreResults(dataRow.Id).then((e) =>
        setTimeout(() => TooltipUtils.rebuild())
      )
    }
  }, [showModalSharedList])

  const handleRedirectToContent = (dataRow) => {
    history.push(`/automation/source/${dataRow.SourceType}/${dataRow.Id}`)
  }

  return (
    <DataListRow key={key} data-mu-test='sources-list-item'>
      <Grid cols={12}>
        <GridCell span={heads[0].span}>
          <Flex justifyContent='space-between'>
            <Flex display='inline-block' width='100%'>
              <Link
                variant='highlight'
                onClick={() => handleRedirectToContent(dataRow)}
                data-mu-test={`sources-list-sourceName-${dataRow.Id}`}
              >
                <TruncateAndTooltip text={dataRow.SourceName} />
              </Link>
            </Flex>

            {moreLoaded && moreShared && (
              <span
                data-tip={intl.formatMessage({
                  id: 'Load.ContentsSouces.ShareTooltip'
                })}
                className='icon-sli icon-share-3'
              />
            )}
          </Flex>
          <Text
            variant={TEXT_VARIANT_SMALL_LIGHT}
            data-mu-test={`sources-list-id-${dataRow.Id}`}
          >
            {intl.formatMessage({
              id: 'Load.MailupCommon.Id'
            })}{' '}
            {dataRow.Id}
          </Text>
        </GridCell>

        <GridCell
          span={heads[1].span}
          data-mu-test={`sources-list-updateDate-${dataRow.Id}`}
        >
          {fromUTCtoZoneFormatted(
            dataRow.UpdateDate,
            TimeZoneCode,
            'YYYY-MM-DD HH:mm'
          )}
        </GridCell>

        <GridCell span={heads[2].span}>
          {moreLoaded ? (
            moreLastContentUpdates != null ? (
              <>
                {fromUTCtoZoneFormatted(
                  moreLastContentUpdates.UpdateDate,
                  TimeZoneCode,
                  'YYYY-MM-DD HH:mm'
                )}
                {dataRow.IsEnabled === false ? (
                  <Flex columnGap='8px' alignItems='baseline'>
                    <StyledIconWarningTriangle
                      variant={ICON_FA_VARIANT_SOLID}
                    />
                    <Text variant={TEXT_VARIANT_SMALL_LIGHT} htmlElement='span'>
                      {intl.formatMessage({
                        id: 'Load.ContentsSouces.UpdateSourcesStop'
                      })}
                    </Text>
                  </Flex>
                ) : (
                  moreLastContentUpdates.Status ===
                    SOURCES_UPDATE_STATUS_KO && (
                    <Flex columnGap='8px' alignItems='baseline'>
                      <StyledIconClose />
                      <Text
                        variant={TEXT_VARIANT_SMALL_LIGHT}
                        htmlElement='span'
                      >
                        {intl.formatMessage({
                          id: 'Load.ContentsSouces.UpdateSourcesFail'
                        })}
                      </Text>
                    </Flex>
                  )
                )}
              </>
            ) : (
              <Flex columnGap='8px' alignItems='baseline'>
                <StyledIconHourglass />
                <Text variant={TEXT_VARIANT_SMALL_LIGHT} htmlElement='span'>
                  {intl.formatMessage({
                    id: 'Load.ContentsSouces.UpdateSourcesNoDefined'
                  })}
                </Text>
              </Flex>
            )
          ) : (
            <SkeletonLoader variant={SKELETON_LOADER_VARIANT_ONWHITE} />
          )}
        </GridCell>

        <GridCell span={heads[3].span}>
          {moreLoaded ? (
            intl.formatNumber(moreContentsNumber, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            })
          ) : (
            <SkeletonLoader variant={SKELETON_LOADER_VARIANT_ONWHITE} />
          )}
        </GridCell>
      </Grid>
      <DataListExtraColumn after width={EXTRA_COLUMN_AFTER_WIDTH}>
        <ActionsMenu info={dataRow} />
      </DataListExtraColumn>
    </DataListRow>
  )
}

export default ItemTable

ItemTable.propTypes = {
  dataRow: PropTypes.object,
  heads: PropTypes.array,
  key: PropTypes.any
}
